import type { ServiceGetByIdResponse } from '@/types/service'

import type {
  RecapFarmerInstitution,
  RecapFarmerInstitutionDetail,
  RecapFarmerInstitutionMeta,
  RecapFarmerInstitutionSummary
} from './types'

type RecordType = 'detail' | 'summary'

export type FarmerInstitutionRecord<TType extends RecordType> =
  TType extends 'detail'
    ? RecapFarmerInstitutionDetail & { type: 'detail' }
    : RecapFarmerInstitutionSummary & { type: 'summary' }

export type RecapFarmerInstitutionData = Array<
  FarmerInstitutionRecord<'detail'> | FarmerInstitutionRecord<'summary'>
>

export interface RecapFarmerInstitutionQueryResult {
  data: RecapFarmerInstitutionData
  meta?: RecapFarmerInstitutionMeta | null
}

type FarmerInstitutionApiResponse = ServiceGetByIdResponse<RecapFarmerInstitution> & {
  meta?: RecapFarmerInstitutionMeta
}

export function toRecords(
  json: FarmerInstitutionApiResponse
): RecapFarmerInstitutionQueryResult {
  const data = json.data

  if (!data) {
    return {
      data: [],
      meta: json.meta ?? null
    }
  }

  const summary = [
    {
      ...data.summary,
      type: 'summary'
    } satisfies FarmerInstitutionRecord<'summary'>
  ]

  const details = data.detail.map(
    item =>
      ({
        ...item,
        type: 'detail'
      }) satisfies FarmerInstitutionRecord<'detail'>
  )

  return {
    data: [...details, ...summary],
    meta: json.meta ?? null
  }
}
